var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"textImageCard",class:[
            { 'textImageCard--active': _vm.selected },
            { 'textImageCard--with-image': _vm.image },
        ],on:{"click":_vm.onSelect}},[_c('v-img',{staticClass:"textImageCard__img",attrs:{"src":_vm.image,"lazy-src":_vm.lazy}}),(_vm.description)?_c('div',{staticClass:"textImageCard__text"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }